<script>
import BaseAvatar from "@/components/BaseAvatar/BaseAvatar.vue";
export default {
  name: "ProfileElectedInfo",
  props: {
    electedInfo: {
      type: Object
    }
  },
  components: {
    BaseAvatar
  },
  computed: {
    forumAvatarUrl() {
      return `/viewimage?type=forum&sh=${this.electedInfo.forumAvatarHash}`;
    },
    orgAvatarUrl() {
      return `/viewimage?type=organization&sh=${this.electedInfo.orhSh}`;
    }
  }
}
</script>

<template>
<div class="profile-elected-info">
  <base-avatar :img-src="forumAvatarUrl"
               size="24"
               v-tooltip.top="electedInfo.forumName"
               class="elected-forum-avatar"
  />
  <div class="elected-info-text">
    <span class="elected-info-text__item">{{electedInfo.forumName}}</span>
    <span class="elected-info-text__item">{{electedInfo.orgName}}</span>
  </div>
  <base-avatar :img-src="orgAvatarUrl"
               size="24"
               v-tooltip.top="electedInfo.orgName"
               class="elected-org-avatar"
  />
</div>
</template>

<style lang="scss" scoped>
.profile-elected-info {
  display: flex;
  justify-content: space-between;
  padding: 4px 6px;
  width: 147px;
  height: 32px;
  border-radius: 16px;
  box-shadow: 0 6px 9px 0 rgba(120, 53, 166, 0.45);
  background-image: linear-gradient(to left, rgba(176, 101, 210, .85), rgba(120, 53, 166, .85));

  .elected-forum-avatar {
    margin-right: 5px;
  }

  .elected-forum-avatar {
    margin-right: 5px;
  }

  .elected-info-text {
    display: flex;
    flex-direction: column;
    &__item {
      max-width: 85px;
      font-size: 11px;
      color: #fff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>